import {
  EnumAlarmType,
  EnumNotificationType,
  EnumTempDeterminer,
} from "../../redux/interfaces";

export const KatalogEvidencijaResourcesBS: KatalogEvidencijaResourcesBSInterface =
  {
    deleteModal: {
      title: "Brisanje evidencije",
      text: "Da li želite obrisati ovu evidenciju?",
      buttonYes: "Obriši",
      buttonNo: "Nazad",
    },
    deleteSuccessModal: {
      title: "Uspješno brisanje",
      body: "Evidencija je uspješno obrisana.",
      buttonOk: "U redu",
    },
    deleteErrorModal: {
      title: "Greška pri brisanju",
      body: "Došlo je do greške tokom brisanja evidencije. Molimo pokušajte ponovo ili kontaktirajte administratora.",
      buttonOk: "U redu",
    },
    checklistConfig: {
      title: "Checklist konfiguracija",
      rowLabel: "Checklist konfiguracija",
      rowPlaceholder: "Definišite nazive stavki checkliste",
      fieldLabelPrefix: "Naziv stavke #",
      checkedByDefaultLabel: "Označi po defaultu",
      addButton: "Dodaj stavku",
      removeButton: "Ukloni",
      buttons: {
        save: "Sačuvaj",
        back: "Nazad",
      },
      errors: {
        load: "Greška pri učitavanju.",
        save: "Greška pri snimanju.",
      },
    },
    errors: {
      poslovnica: "Molimo odaberite poslovnicu.",
      katalogEvidencijaBranches:
        "Greska tokom loadiranja. Molimo kontaktirajte administratora.",
      deleteError:
        "Doslo je do greske tokom brisanja konfiguracije. Molimo kontaktirajte administratora.",
    },
    successModal: {
      title: "Unos podataka",
      body: "Dodavanje podataka je uspješno završeno. Odaberite OK za nastavak.",
      buttonOk: "OK",
    },
    editDescription: {
      title: "Obrada opisa",
    },
    addButton: "Dodaj novi",
    evidencijePlaceholder: "Evidencije nisu pronadjene",
    evidencijeOdabirPoslovnice: "Izaberite poslovnicu",
    typeEvidencije: {
      occasionally: "Po potrebi",
      redovna: "Redovna",
      placeholder: "Molimo odaberite kategoriju",
    },
    vrsteEvidencije: {
      evidencija: "Evidencija",
      template: "Template",
    },
    evidencijaForm: {
      title: "Katalog Evidencija Form",
      markdownContent: {
        name: "markdownContent",
        error: "Error Markdown Content",
        label: "Detaljan Opis",
        placeholder: "",
      },
      branch: {
        label: "Odaberite poslovnicu",
        placeholder: "Odaberite poslovnicu",
        noOptions: "Poslovnice nisu pronadjene",
        name: "branch",
        error: "",
      },
      typeList: {
        label: "Odaberite kategoriju",
        placeholder: "Odaberite kategoriju",
        noOptions: "Kategorije nisu pronadjene",
        name: "typeList",
        error: "",
      },
      revizija: {
        label: "Revizija",
        placeholder: "Dodajte verziju revizije",
        name: "revizija",
        error: "Dodajte verziju revizije",
      },
      description: {
        label: "Opis",
        placeholder: "Dodajte opis",
        name: "description",
        error: "Dodajte opis",
      },
      titleForm: {
        label: "Naziv evidencije",
        placeholder: "Dodajte naziv evidencije",
        name: "title",
        error: "Dodajte naziv evidencije",
      },
      category: {
        label: "Odaberite tip evidencije",
        placeholder: "Odaberite tip",
        noOptions: "Tipovi nisu pronadjeni",
        name: "category",
        error: "",
      },
      buttonForward: "Dodaj",
      buttonBack: "Nazad",
      successModal: {
        title: "Unos podataka",
        body: "Dodavanje podataka je uspješno završeno. Odaberite OK za nastavak.",
        buttonOk: "OK",
      },
    },
    autocompleteConfig: {
      title: "Konfiguracija automatskog popunjavanja",
      enabled: {
        label: "Omogući automatsko popunjavanje",
        name: "enabled",
      },
      signerType: {
        label: "Tip potpisnika",
        name: "signerType",
        options: {
          user: "Konkretan korisnik",
          position: "Pozicija/Uloga",
        },
        note: "Promjena tipa potpisnika će obrisati samo trenutni odabir potpisnika za automatsko popunjavanje, ali neće utjecati na odgovorne osobe.",
      },
      signer: {
        label: "Potpisnik",
        name: "signer",
        placeholder: "Unesite ID korisnika ili poziciju",
      },
      fieldValues: {
        title: "Konfiguracija vrijednosti polja",
        description:
          "Konfigurišite vrijednosti za određena polja. Koristite tačku-zarez (;) za odvajanje više vrijednosti za nasumičan odabir.",
        fieldName: {
          label: "Naziv polja",
          placeholder: "Odaberite polje",
        },
        values: {
          label: "Vrijednosti (odvojite sa ;)",
          placeholder: "vrijednost1; vrijednost2; vrijednost3",
        },
        addButton: "Dodaj vrijednost polja",
        removeButton: "Ukloni",
      },
      pointScope: {
        label: "Tačka primjene",
        allPoints: "Sve tačke primjene",
        hintAll:
          "Vrijednosti vrijede za sve tačke primjene, osim onih koje imaju poseban override.",
        hintPoint:
          "Posebne vrijednosti samo za odabranu tačku primjene. Ostale tačke koriste postavke iz „Sve tačke primjene“.",
        hasOverride: "Posebne postavke",
        clearOverride: "Vrati na zajedničke postavke",
        noPoints:
          "Nema konfiguriranih tačaka primjene. Prvo ih dodajte u koraku Tačke primjene.",
      },
      successModal: {
        title: "Uspješno!",
        body: "Konfiguracija automatskog popunjavanja je uspješno sačuvana.",
        buttonOk: "U redu",
      },
      buttons: {
        save: "Sačuvaj konfiguraciju",
        back: "Nazad",
      },
    },
    kreiranjeEvidencije: {
      errorMissingFields:
        "Molimo popunite sva polja, da bi mogli aktivirati evidenciju.",
      errorCreation: "Doslo je do greske. Molimo kontaktirajte administratora.",
      description: {
        label: "Opisi",
        placeholder: "Unesite opis",
        name: "opis",
        error: "",
      },
      tempConfigPolja: {
        name: "tempConfig",
        label: "Konfiguracija temperature",
        placeholder: "Molimo unesite konfiguraciju temperature",
        title: "Konfiguracija Temperature",
        dozvoljenaTempMin: {
          label: "Minimalna dozvoljena temperatura",
          name: "dozvoljenaTempMin",
          placeholder: "Molimo unesite minimalnu temperaturu",
        },
        dozvoljenaTempMax: {
          label: "Maksimalna dozvoljena temperatura",
          name: "dozvoljenaTempMax",
          placeholder: "Molimo unesite ocitanu temperaturu",
        },
        dozvoljenoOdstupanje: {
          label: "Dozvoljeno odstupanje",
          name: "dozvoljenoOdstupanje",
          placeholder: "Molimo unesite dozvoljeno odstupanje",
        },
      },
      status: {
        activate: "Aktiviraj",
        deactivate: "Deaktiviraj",
        saveAs: "Nova verzija",
      },
      nazivEvidencije: {
        title: "Kreiranje Evidencije",
        label: "Naziv evidencije",
        placeholder: "Dodajte naziv evidencije",
        name: "title",
        error: "Dodajte naziv evidencije",
      },
      revizija: {
        title: "Revizija",
        label: "Revizija",
        placeholder: "Dodajte reviziju",
        name: "revizija",
        error: "Dodajte reviziju",
      },
      tackePrimjene: {
        title: "Tacke primjene",
        label: "Tacke primjene",
        placeholder: "Odaberite tacke primjene",
        name: "recordPoints",
        error: "Nije odabrana tacka primjene",
      },
      ucestalost: {
        title: "Ucestalost Evidentiranja",
        label: "Ucestalost Evidentiranja",
        placeholder: "Odaberite ucestalost evidentiranja",
        name: "frequency",
        error: "Nije odabrana ucestalost evidentiranja",
        visegodisnje: {
          title: "Višegodišnje",
          btnVisegodisnje: "Višegodišnje",
          btnDatum: "Datum",
        },
        godisnje: {
          title: "Godišnje",
          btnGodisnje: "Godišnje",
          btnDatum: "Datum",
        },
        mjesecno: {
          title: "Mjesecno",
          btnMjesecno: "Mjesecno",
          btnDatumPocetak: "Datum početak",
          btnDatumKraj: "Datum završetak",
          btnBrojanje: "Početak od",
          lblSvaki: "Svaki ",
          lblMjesec: "mjesec",
        },
        sedmicno: {
          title: "Sedmicno",
          btnSedmicno: "Sedmicno",
          btnDatumPocetak: "Datum početak",
          btnDatumKraj: "Datum završetak",
          btnBrojanje: "Početak od",
          lblSvake: "Svake ",
          lblSedmice: "sedmice",
          errorBeginDate: "Odaberite sedmicu (YYYY-Www) prije spremanja.",
        },
        dnevno: {
          title: "Dnevno",
          btnDnevno: "Dnevno",
          btnPocetak: "Početak",
          btnKraj: "Završetak",
          btnBrojanje: "Početak od",
          lblSvaki: "Svaki ",
          lblDan: "dan",
          skipSaturday: "Preskoči Subotu",
          skipSunday: "Preskoči Nedjelju",
        },
        poPotrebi: {
          btnPoPotrebi: "Po potrebi",
        },
      },
      odgovorneOsobe: {
        title: "Odgovorne Osobe",
        label: "Odgovorne Osobe",
        placeholder: "Odaberite odgovorne osobe",
        name: "dedicatedUsers",
        error: "Nije odabrana odgovorna osoba",
      },
      tpEvidencije: {
        title: "Tacke Primjene",
        back: "Nazad",
        next: "Spasi promjene",
      },
      podsjetnik: {
        title: "Podsjetnik",
        label: "Podsjetnik",
        placeholder: "Dodaj podsjetnik",
        name: "notifications",
        btnTitle: "+ Dodaj podsjetnik",
      },
      poljeEvidencije: {
        title: "Vrsta Evidencije",
        label: "Vrsta Evidencije",
        placeholder: "Dodaj vrstu evidencije",
        name: "poljeEvidencije",
        error: "",
      },
      autocompleteConfig: {
        title: "Konfiguracija automatskog popunjavanja",
        enabled: {
          label: "Omogući automatsko popunjavanje",
          name: "enabled",
        },
        signerType: {
          label: "Tip potpisnika",
          name: "signerType",
          options: {
            user: "Konkretan korisnik",
            position: "Pozicija/Uloga",
          },
          note: "Promjena tipa potpisnika će automatski obrisati postojeće odabire korisnika/kategorija kako bi se izbjegla konfuzija između konkretnih korisnika i kategorija.",
        },
        signer: {
          label: "Potpisnik",
          name: "signer",
          placeholder: "Unesite ID korisnika ili poziciju",
        },
        fieldValues: {
          title: "Konfiguracija vrijednosti polja",
          description:
            "Konfigurišite vrijednosti za određena polja. Koristite tačku-zarez (;) za odvajanje više vrijednosti za nasumičan odabir.",
          fieldName: {
            label: "Naziv polja",
            placeholder: "Odaberite polje",
          },
          values: {
            label: "Vrijednosti (odvojite sa ;)",
            placeholder: "vrijednost1; vrijednost2; vrijednost3",
          },
          addButton: "Dodaj vrijednost polja",
          removeButton: "Ukloni",
        },
        pointScope: {
          label: "Tačka primjene",
          allPoints: "Sve tačke primjene",
          hintAll:
            "Vrijednosti vrijede za sve tačke primjene, osim onih koje imaju poseban override.",
          hintPoint:
            "Posebne vrijednosti samo za odabranu tačku primjene. Ostale tačke koriste postavke iz „Sve tačke primjene“.",
          hasOverride: "Posebne postavke",
          clearOverride: "Vrati na zajedničke postavke",
          noPoints:
            "Nema konfiguriranih tačaka primjene. Prvo ih dodajte u koraku Tačke primjene.",
        },
        successModal: {
          title: "Uspješno!",
          body: "Konfiguracija automatskog popunjavanja je uspješno sačuvana.",
          buttonOk: "U redu",
        },
        buttons: {
          save: "Sačuvaj konfiguraciju",
          back: "Nazad",
        },
      },
      obavijesti: {
        title: "Obavijesti",
        cbNotifikacija: "Po isteku - notifikacija",
        plcPeriod: "Period",
        optPeriod: [
          {
            value: EnumTempDeterminer.MINUTA,
            label: "Minuta",
          },
          {
            value: EnumTempDeterminer.SATI,
            label: "Sati",
          },
          {
            value: EnumTempDeterminer.DANA,
            label: "Dana",
          },
        ],
        plcKada: "Prije/poslije",
        optKada: [
          {
            value: EnumAlarmType.beforeStart,
            label: "Prije početka",
          },
          {
            value: EnumAlarmType.afterStart,
            label: "Poslije početka",
          },
          {
            value: EnumAlarmType.beforeEnd,
            label: "Prije isteka",
          },
          {
            value: EnumAlarmType.afterEnd,
            label: "Poslije isteka",
          },
        ],
        plcKako: "Obavijest",
        optKako: [
          {
            value: EnumNotificationType.email1,
            label: "E-mail zaduženim osobama",
          },
          {
            value: EnumNotificationType.email2,
            label: "E-mail menadžerima",
          },
          {
            value: EnumNotificationType.email3,
            label: "E-mail šefovima",
          },
          {
            value: EnumNotificationType.sms1,
            label: "SMS zaduženim osobama",
          },
          {
            value: EnumNotificationType.sms2,
            label: "SMS menadžerima",
          },
          {
            value: EnumNotificationType.sms3,
            label: "SMS šefovima",
          },
          {
            value: EnumNotificationType.call1,
            label: "Poziv zaduženim osobama",
          },
          {
            value: EnumNotificationType.call2,
            label: "Poziv menadžerima",
          },
          {
            value: EnumNotificationType.call3,
            label: "Poziv šefovima",
          },
        ],
      },
      language: {
        title: "Jezik",
        label: "Jezik",
        placeholder: "Odaberite jezik",
        name: "language",
        options: {
          bs: "Bosanski",
          en: "Engleski",
          de: "Njemački",
        },
      },
      manager: {
        label: "Menadžer",
        placeholder: "Odaberite menadžera",
        notFound: "Korisnici nisu pronađeni",
      },
      isPublic: {
        title: "Javni pristup",
        label: "Evidencija je javna",
        description: "Ako je označeno, evidencija će biti dostupna javno",
      },
      notifyManagersOnFeedback: {
        title: "Obavijest menadžerima",
        label: "Šalji e-mail menadžerima pri novom feedbacku",
        description:
          "Ako je označeno, menadžeri poslovnice dobijaju e-mail svaki put kada stigne novi feedback",
      },
      qrCode: {
        button: "Generiši QR kod",
        modalTitle: "Generiši QR kod",
        selectLabel: "Odaberite tačku primjene",
        selectPlaceholder: "Odaberite tačku primjene...",
        generateButton: "Generiši QR kod",
        downloadButton: "Preuzmi QR kod",
        cancelButton: "Otkaži",
        noRecordPointsError: "Nema konfigurisanih tačaka primjene. Molimo prvo konfigurišite tačke primjene.",
        downloadError: "Došlo je do greške prilikom preuzimanja QR koda. Molimo pokušajte ponovo.",
      },
      details: {
        title: "Detalji",
        recordPointIds: "ID-ovi tačaka primjene",
        noRecordPoints: "Tačke primjene još nisu generisane",
      },
    },
  };

export interface TaskTypes {
  recordTraceConfigId: number;
  category: string;
  title: string;
  description: string;
  status: boolean;
  revizija?: string;
}

export const tasks: TaskTypes[] = [];

interface InputField {
  label: string;
  placeholder: string;
  name: string;
  title?: string;
  error: string;
  noOptions?: string;
  description?: () => JSX.Element;
}

interface OptionEnumTempDeterminer {
  value: EnumTempDeterminer;
  label: string;
}

interface OptionEnumAlarmType {
  value: EnumAlarmType;
  label: string;
}

interface OptionEnumNotificationType {
  value: EnumNotificationType;
  label: string;
}

interface EvidencijaForm {
  title: string;
  branch: InputField;
  revizija: InputField;
  typeList: InputField;
  description: InputField;
  titleForm: InputField;
  category: InputField;
  markdownContent: InputField;
  buttonForward: string;
  buttonBack: string;
  successModal: SuccessModal;
  // Add other fields as needed
}

interface SuccessModal {
  title: string;
  body: string;
  buttonOk: string;
}

interface KreiranjeEvidencije {
  status: {
    activate: string;
    deactivate: string;
    saveAs: string;
  };
  revizija: InputField;
  description: InputField;
  nazivEvidencije: InputField;
  tackePrimjene: InputField;
  ucestalost: Ucestalost;
  odgovorneOsobe: InputField;
  tpEvidencije: {
    title: string;
    back: string;
    next: string;
  };
  podsjetnik: Podsjetnik;
  poljeEvidencije: InputField;
  obavijesti: Obavijesti;
  tempConfigPolja: ItempConfigPolja;
  autocompleteConfig: IAutocompleteConfig;
  language: {
    title: string;
    label: string;
    placeholder: string;
    name: string;
    options: {
      bs: string;
      en: string;
      de: string;
    };
  };
  manager: {
    label: string;
    placeholder: string;
    notFound: string;
  };
  isPublic: {
    title: string;
    label: string;
    description: string;
  };
  notifyManagersOnFeedback: {
    title: string;
    label: string;
    description: string;
  };
  qrCode: {
    button: string;
    modalTitle: string;
    selectLabel: string;
    selectPlaceholder: string;
    generateButton: string;
    downloadButton: string;
    cancelButton: string;
    noRecordPointsError: string;
    downloadError: string;
  };
  details: {
    title: string;
    recordPointIds: string;
    noRecordPoints: string;
  };
  errorCreation: string;
  errorMissingFields: string;
}

interface Ucestalost {
  title: string;
  label: string;
  placeholder: string;
  name: string;
  error: string;
  visegodisnje: Visegodisnje;
  godisnje: Godisnje;
  mjesecno: Mjesecno;
  sedmicno: Sedmicno;
  dnevno: Dnevno;
  poPotrebi: PoPotrebi;
}

interface Visegodisnje {
  title: string;
  btnVisegodisnje: string;
  btnDatum: string;
}

interface Godisnje {
  title: string;
  btnGodisnje: string;
  btnDatum: string;
}

interface Mjesecno {
  title: string;
  btnMjesecno: string;
  btnDatumPocetak: string;
  btnDatumKraj: string;
  btnBrojanje: string;
  lblSvaki: string;
  lblMjesec: string;
}

interface Sedmicno {
  title: string;
  btnSedmicno: string;
  btnDatumPocetak: string;
  btnDatumKraj: string;
  btnBrojanje: string;
  lblSvake: string;
  lblSedmice: string;
  errorBeginDate: string;
}

interface Dnevno {
  title: string;
  btnDnevno: string;
  btnPocetak: string;
  btnKraj: string;
  btnBrojanje: string;
  lblSvaki: string;
  lblDan: string;
  skipSaturday: string;
  skipSunday: string;
}

interface PoPotrebi {
  btnPoPotrebi: string;
}

// Define similar interfaces for Godisnje, Mjesecno, Sedmicno, Dnevno, and PoPotrebi as needed based on your structure

interface Podsjetnik {
  title: string;
  label: string;
  placeholder: string;
  name: string;
  btnTitle: string;
}

interface Obavijesti {
  title: string;
  cbNotifikacija: string;
  plcPeriod: string;
  optPeriod: OptionEnumTempDeterminer[];
  plcKada: string;
  optKada: OptionEnumAlarmType[];
  plcKako: string;
  optKako: OptionEnumNotificationType[];
}

interface DeleteModal {
  title: string;
  text: string;
  buttonYes: string;
  buttonNo: string;
}

interface DeleteResultModal {
  title: string;
  body: string;
  buttonOk: string;
}

export interface KatalogEvidencijaResourcesBSInterface {
  addButton: string;
  evidencijePlaceholder: string;
  evidencijeOdabirPoslovnice: string;
  evidencijaForm: EvidencijaForm;
  kreiranjeEvidencije: KreiranjeEvidencije;
  autocompleteConfig: IAutocompleteConfig;
  deleteModal: DeleteModal;
  deleteSuccessModal: DeleteResultModal;
  deleteErrorModal: DeleteResultModal;
  vrsteEvidencije: {
    template: string;
    evidencija: string;
  };
  typeEvidencije: {
    redovna: string;
    occasionally: string;
    placeholder: string;
  };
  errors: {
    poslovnica: string;
    katalogEvidencijaBranches: string;
    deleteError: string;
  };
  successModal: {
    title: string;
    body: string;
    buttonOk: string;
  };
  editDescription: {
    title: string;
  };
  checklistConfig: ChecklistConfig;
}

interface ItempConfigPolja {
  title: string;
  name: string;
  label: string;
  placeholder: string;
  dozvoljenaTempMin: {
    label: string;
    name: string;
    placeholder: string;
  };
  dozvoljenaTempMax: {
    label: string;
    name: string;
    placeholder: string;
  };
  dozvoljenoOdstupanje: {
    label: string;
    name: string;
    placeholder: string;
  };
}

interface IAutocompleteConfig {
  title: string;
  enabled: {
    label: string;
    name: string;
  };
  signerType: {
    label: string;
    name: string;
    options: {
      user: string;
      position: string;
    };
    note: string;
  };
  signer: {
    label: string;
    name: string;
    placeholder: string;
  };
  fieldValues: {
    title: string;
    description: string;
    fieldName: {
      label: string;
      placeholder: string;
    };
    values: {
      label: string;
      placeholder: string;
    };
    addButton: string;
    removeButton: string;
  };
  pointScope: {
    label: string;
    allPoints: string;
    hintAll: string;
    hintPoint: string;
    hasOverride: string;
    clearOverride: string;
    noPoints: string;
  };
  successModal: {
    title: string;
    body: string;
    buttonOk: string;
  };
  buttons: {
    save: string;
    back: string;
  };
}

interface ChecklistConfig {
  title: string;
  rowLabel: string;
  rowPlaceholder: string;
  fieldLabelPrefix: string;
  checkedByDefaultLabel: string;
  addButton: string;
  removeButton: string;
  buttons: { save: string; back: string };
  errors: { load: string; save: string };
}
